"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyLogger = void 0;
class EmptyLogger {
    append(message) { }
    appendLine(message) { }
    cleanup() { }
    debug(message) { }
    error(message) { }
    info(message) { }
    printDetailLog() { }
    warning(message) { }
}
exports.EmptyLogger = EmptyLogger;
//# sourceMappingURL=depsLogger.js.map